export const enum TabsUnverifiedTripsEnum {
  UnverifiedTrips = 1,
  ExportZoll = 2,
  ElectronicSubmissions = 3,
  ECM = 4,
  Forms = 5,
  SummaryTrips = 6,
  Rejections = 7
}



// WEBPACK FOOTER //
// ./src/app/core/enums/tabs-unverified-trips.enum.ts